import { render, staticRenderFns } from "./Page404NotFound.vue?vue&type=template&id=4b50a953&"
import script from "./Page404NotFound.vue?vue&type=script&lang=js&"
export * from "./Page404NotFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports